export const styleSheet = theme => ({
    container: {
        cursor: 'pointer',
        height: 30,
        display: 'flex',
        alignItems: 'center',
        padding: theme.margins.margin00,
        borderRadius: 15,
        overflow: 'hidden',
        svg: {
            marginLeft: 5
        }
    },
    labelText: {
        maxWidth: 350,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }
});
